module.exports = __webpack_public_path__ + "static/img/hzhblogo.4df5244.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/icons/hzhblogo.png
// module id = pxlk
// module chunks = 6